import React, { Component } from "react";
import StepWizard from "react-step-wizard";
//// componentes reutilizables
import Titulo from "../../../generico/TituloPagina";
import Paso1 from "../PagoDepositoExtraccionQr/PagoDepositoExtraccionQrPaso1";
import Paso2 from "../PagoDepositoExtraccionQr/PagoDepositoExtraccionQrPaso2";
import Paso3 from "../PagoDepositoExtraccionQr/PagoDepositoExtraccionQrPaso3";
import Paso4 from "../PagoDepositoExtraccionQr/PagoDepositoExtraccionQrPaso4";

export default class PagoDepositoExtraccionQr extends Component {
  constructor(props) {
    super(props);
    this.state = this.getInitialState();
    this.paso1 = React.createRef();
    this.paso2 = React.createRef();
    this.paso3 = React.createRef();
    this.paso4 = React.createRef();
  }
  resetState = () => {
    this.setState(this.getInitialState());
  };
  getInitialState = () => ({
    cuentaOrigen: {},
    datosQR: {},
    importe: 0,
    nroOperacion: 0,
    comercio:"",
    modalidadPagoMotivo:"",
    tipoFondo: ""
  });
  returnDataPaso1( _datosQR) {
    this.setState({
      datosQR: _datosQR,
    });
  }
  returnDataPaso2(_tipoQR, _comercio, _importe, _modalidadPagoMotivo, _cuentaOrigen) {
    this.setState({
      datosTipoQR: _tipoQR,
      comercio: _comercio,
      importe: _importe,
      modalidadPagoMotivo: _modalidadPagoMotivo,
      cuentaOrigen: _cuentaOrigen,
    });
  }
  returnDataPaso3(_nroOperacion, _tipoQR, _comercio, _importe, _formaPago, _datoPago, _tipoFondo) {
    this.setState({
      nroOperacion: _nroOperacion,
      datosTipoQR: _tipoQR,
      comercio: _comercio,
      importe: _importe,
      formaPago: _formaPago,
      datoPago: _datoPago,
      tipoFondo: _tipoFondo
    });
  }
  returnDataPaso4() {
    this.setState(this.getInitialState());
  }


  onStepChange = (stats) => {  
    if (stats.previousStep === 2) {      
    }
  };
  componentDidMount() {}

  render() {
    return (
      <div className="content-wrapper">
        <Titulo texto="Leer QR" />
        <section className="content">
          <div className="container">
            <div className="row">
              <div className="col-md-12">
                <div className="card" >
                  <div className="card-body" style={{zIndex: 0}}>
                    <StepWizard
                      isLazyMount={true}
                      onStepChange={this.onStepChange}
                      transitions="none"
                    >
                      <Paso1
                        ref={this.paso1}
                        returnDataPaso1={this.returnDataPaso1.bind(this)}
                      />
                      <Paso2
                        ref={this.paso2}
                        cuentaOrigen={this.state.cuentaOrigen}
                        datosQR={this.state.datosQR}
                        returnDataPaso2={this.returnDataPaso2.bind(this)}
                      />
                      <Paso3
                        ref={this.paso3}
                        cuentaOrigen={this.state.cuentaOrigen}
                        datosQR={this.state.datosQR}
                        modalidadPagoMotivo={this.state.modalidadPagoMotivo}
                        importe={this.state.importe}
                        comercio={this.state.comercio}
                        datosTipoQR={this.state.datosTipoQR}
                        returnDataPaso3={this.returnDataPaso3.bind(this)}
                      />
                      <Paso4
                        ref={this.paso4}
                        nroOperacion={this.state.nroOperacion}
                        importe={this.state.importe}
                        comercio={this.state.comercio}                        
                        formaPago={this.state.formaPago}
                        datoPago={this.state.datoPago}
                        datosTipoQR={this.state.datosTipoQR}
                        datosQR={this.state.datosQR}
                        tipoFondo={this.state.tipoFondo}
                        cuentaOrigen={this.state.cuentaOrigen}
                        motivo={this.state.modalidadPagoMotivo}
                        returnDataPaso4={this.returnDataPaso4.bind(this)}
                      />
                    </StepWizard>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    );
  }
}
